export default "/images/vendor/flag-icon-css/flags/4x3/eu.svg?0420e634b15c416fbdc13765fa79dc19";